/**
 * Inline responses for the carrier invoice and audit endpoints.
 *
 * Grouped out of inlineResponses.tsx to keep that file under the 400-line
 * limit, following the sibling-group convention documented there.
 */
export const CARRIER_INVOICE_INLINE_RESPONSES: Record<
  string,
  Record<string, unknown> | unknown[]
> = {
  // Financial pages — return empty data until real fixtures are exported
  "/apollo/carrier-invoice/view-carrier-invoices": {
    nonVoidedCarrierInvoices: [],
    invoicesReadyToPay: [],
  },
  "/apollo/carrier-invoice/shipments-overdue-invoices": {
    shipmentsWithOverdueInvoices: [],
    shipmentsWithoutInvoices: [],
  },
  "/apollo/carrier-invoice/view-carrier-credit-notes": [],
  // Carrier invoice dialog — payment properties are fetched on open.
  // allowedCurrencyCodes is required by the spec; the generated deserializer
  // calls .map() on it unguarded, so an empty {} crashes with a TypeError
  // that surfaces as a "Load payment properties" error toast.
  "/apollo/carrier-invoice/get-payment-properties": {
    allowedCurrencyCodes: [],
  },
  // Carrier request audit dialog — returns empty array for snapshot rendering
  "/apollo/carrier-invoice/get-carrier-request-audit-for-selected-quote": [],
  // Carrier Request Audits dialog (ViewShipmentCarrierRequestAuditsDialog) —
  // the response deserializer calls jsonValue.map(), so an unmapped endpoint
  // crashes with a "Cannot read properties of undefined (reading 'map')"
  // TypeError. Empty array renders the dialog's empty state.
  "/apollo/shipments/carrier-request-audits-for-shipment": [],
  // Tracking line audits dialog — returns empty array; snapshot exercises the empty state
  "/apollo/carrier-request-audit/get-audits-by-tracking-line": [],
  // Carrier invoice dialog — carrier audit notes fetched by the notes section
  "/apollo/carrier-invoice-audit/get-all-invoice-carrier-notes": [],
  // Audit problem dialog — problem type notes fetched by the notes section
  "/apollo/carrier-invoice-audit/get-all-invoice-problem-notes": [],
  // Carrier history dialog — shipments per carrier for audit history
};
